<template>
  <v-col v-if="editObject" :cols="isPadBool ? 12 : 4" style="height: 100%;">
    <v-divider v-if="isPadBool" />
    <v-row no-gutters style="flex-grow: 0;">
      <v-col cols="12">
        <v-divider></v-divider>
        <div style="height: 50px;" class="d-flex align-center px-3">
          <h3 v-text="'KPI'" />
        </div>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row no-gutters style="flex-grow: 1;">
      <v-col class="pb-2">
        <h5 v-text="$t('servicesystem.common_objects.kpi.performance')" class="useThemeTextColor mt-1 mx-3" />
        <v-checkbox v-model="editObject.KpifirstTimeFix" :label="$t('servicesystem.common_objects.kpi.first_time_fix')"
          :ripple="false" class="mt-0 mx-2" hide-details @change="save()">
        </v-checkbox>
        <v-checkbox v-model="editObject.KpiphoneFix" :label="$t('servicesystem.common_objects.kpi.phone_fix')"
          :ripple="false" class="mt-0 mx-2" hide-details @change="save()">
        </v-checkbox>
        <v-checkbox v-model="editObject.Kpirecall" :label="$t('servicesystem.common_objects.kpi.recall')"
          :ripple="false" class="mt-0 mx-2" hide-details @change="save()">
        </v-checkbox>
        <v-checkbox v-model="editObject.Kpirewrite" :label="$t('servicesystem.common_objects.kpi.rewrite')"
          :ripple="false" class="mt-0 mx-2" hide-details @change="save()">
        </v-checkbox>
        <h5 v-text="$t('servicesystem.common_objects.kpi.lifecycle')" class="useThemeTextColor mt-2 mx-3" />
        <v-checkbox v-model="editObject.KpiplannedMaintenance"
          :label="$t('servicesystem.common_objects.kpi.planned_maintenance')" :ripple="false" class="mt-0 mx-2"
          hide-details @change="save()">
        </v-checkbox>
        <v-checkbox v-model="editObject.Kpiremoval" :label="$t('servicesystem.common_objects.kpi.removal')"
          :ripple="false" class="mt-0 mx-2" hide-details @change="save()">
        </v-checkbox>
        <v-checkbox v-model="editObject.Kpiinstall" :label="$t('servicesystem.common_objects.kpi.install')"
          :ripple="false" class="mt-0 mx-2" hide-details @change="save()">
        </v-checkbox>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="6" class="px-3">
        <h5 v-text="$t('servicesystem.common_objects.kpi.time')" class="useThemeTextColor mt-1" />
        <QDateTimeField3 v-model="editObject.CreatedDate" :label="$t('servicesystem.common_objects.kpi.created_date')"
          @change="save()">
        </QDateTimeField3>
        <QDateTimeField3 v-model="editObject.PlannedDate" :label="$t('servicesystem.common_objects.kpi.planned_date')"
          @change="save()">
        </QDateTimeField3>
        <QDateTimeField3 v-model="editObject.ResponseDate" :label="$t('servicesystem.common_objects.kpi.response_date')"
          @change="save()">
        </QDateTimeField3>
        <QDateTimeField3 v-model="editObject.CompletedDate"
          :label="$t('servicesystem.common_objects.kpi.completed_date')" @change="save()">
        </QDateTimeField3>
        <QDateTimeField3 v-model="editObject.ClosedDate" :label="$t('servicesystem.common_objects.kpi.closed_date')"
          @change="save()">
        </QDateTimeField3>
      </v-col>
    </v-row>
  </v-col>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QDateTimeField3 from "@/components/Inputs/QDateTimeField3.vue";

export default {
  name: "MachinejobKPIOptions",
  props: {
    childJobId: Number,
    refreshTrigger: Number,
  },
  components: {
    QDateTimeField3,
  },
  mixins: [clientAPI],

  data() {
    return {
      edittrigger: 1,
      editObject: null,
      copyObject: null,
    };
  },

  mounted() {
    this.get();
  },

  methods: {
    async get() {
      if (this.childJobId) {
        this.loading = true;

       await this.getKPIDetails(this.childJobId)
          .then((response) => {
            if (response) {
              this.editObject = Object.assign({}, response);
              this.copyObject = Object.assign({}, response);
            } else {
              this.editObject = null;
              this.copyObject = null;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    async save() {
      this.loading = true;
      await this.setKPIOptions(this.editObject)
        .then((response) => {
          this.editObject = Object.assign({}, response);
          this.copyObject = Object.assign({}, response);
          console.log("KPI options saved", response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  computed: {},

  watch: {
    refreshTrigger: function () {
      console.log("refreshTrigger", this.refreshTrigger);
      this.get();
    },

    childJobId: function () {
      this.get();
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .v-input--checkbox .v-label {
  font-size: 13px !important;
}
</style>